'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.tasksTemplates', {
            url: '/tasksTemplates',
            templateUrl: 'dashboard-tasks-templates/dashboard-tasks-templates.html',
            controller: 'dashboardTasksTemplatesCtrl as ctrl',
            resolve: {
                templates: ['$stateParams', 'Department', function($stateParams, Department) {
                    return Department.tasktemplate({
                        id: $stateParams.departmentId,
                        filter: {
                            include: 'form'
                        }
                    }).$promise;
                }]
            },
            data: {
                authorizedRoles: ['admin','owner','supervisor','fieldAdmin']
            }
        });
};
